import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

import { PreviewImage } from '../PreviewImage';
import useStore from '../../../../shared/store';

interface IMidiaModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageId: string;
}

export function MidiaModal({ isOpen, onClose, imageId }: IMidiaModalProps) {
  const selected = useStore((s) => s.banners.selectedBanner);
  const api = useStore((state) => state.api);
  const media = selected?.id === imageId ? selected.media : { imageUrl: '', cupom: '' };

  const { imageUrl: initialImage, cupom: initialCoupon } = media;
  const initialRef = useRef<HTMLInputElement>(null);
  const finalRef = useRef<HTMLButtonElement>(null);
  const { register, handleSubmit, reset } = useForm<{ coupon: string }>({
    defaultValues: { coupon: initialCoupon },
  });
  const [preview, setPreview] = useState(initialImage);

  const onSave = handleSubmit(async (data) => {
    await api.saveBanner({
      id: imageId,
      media: { imageUrl: preview, cupom: data.coupon },
    });
    await api.fetchBanners();
    onClose();
  });

  const onCancel = () => {
    api.dispatchSelectedBanner(imageId, { imageUrl: undefined, cupom: '' });
    onClose();
  };

  const onDelete = async () => {
    await api.deleteBanner(imageId);
    await api.fetchBanners();
  };

  useEffect(() => {
    setPreview(initialImage);
    reset({ coupon: initialCoupon });
  }, [initialImage, initialCoupon, reset]);

  return (
    <>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size="3xl"
      >
        <ModalOverlay />

        <ModalContent borderRadius="2xl">
          <form onSubmit={onSave}>
            <ModalBody padding="24px" display="flex" flexDirection="column" gap={4}>
              <VStack spacing={4}>
                <PreviewImage
                  previewImage={preview || ''}
                  id={imageId}
                  hasImage={!!preview}
                  onDelete={onDelete}
                />

                <FormControl>
                  <FormLabel htmlFor="coupon">Cupom</FormLabel>
                  <Input
                    id="coupon"
                    placeholder="Digite o código do cupom"
                    {...register('coupon')}
                  />
                </FormControl>
              </VStack>
            </ModalBody>

            <ModalFooter>
              <Button mr={3} onClick={onCancel}>
                Cancelar
              </Button>
              <Button colorScheme="primary" type="submit">
                Salvar
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
}
